import React, { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import NoData from "../noData";
import Table from "../table";

const ViewReport = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { state } = location;

  const { columns, rows, info, sortBy, orderBy } = state.data;

  // handle Download Csv

  const handleGoBack = () => {
    const newPathname = location.pathname.replace("/view-report", "");
    navigate(newPathname);
  };

  const getSortByColumn = () => {
    let sortByCol = "";
    if (sortBy.includes(".")) {
      const arr = sortBy.split(".");
      sortByCol = arr[arr.length - 1].toLowerCase();
    } else sortByCol = sortBy.toLowerCase();
    return sortByCol;
  };
  let sortByCol = getSortByColumn();

  // column builder

  const columnBuilder = React.useCallback((tableData) => {
    if (tableData.length === 0) return [];

    const columnKeys = Object.keys(tableData[0]);

    const columns = columnKeys.map((item) => {
      return {
        Header: item,
        accessor: item,
      };
    });

    return columns;
  }, []);

  const generateColumnsData = (columns, rows) => {
    if (rows.length === 0) return [];

    let tableData = rows.map((row) => {
      let item = {};
      columns.map((column) => {
        if (column.value === sortByCol) {
          localStorage.setItem(
            "sort",
            JSON.stringify({
              id: column.key,
              desc: orderBy === "desc" ? true : false,
            })
          );
        }
        item = {
          ...item,
          [column.key]: row.hasOwnProperty(column.value)
            ? row[column.value]
            : "",
        };
      });
      return item;
    });
    return tableData;
  };

  // responsible for lowercasing the columns values
  const getLowercaseColumnsValues = (columns) => {
    const lowercaseColumnsValues = columns.map((column) => {
      if (column.value.includes(".")) {
        const arr = column.value.split(".");
        return { ...column, value: arr[arr.length - 1].toLowerCase() };
      } else {
        return { ...column, value: column.value.toLowerCase() };
      }
    });

    return lowercaseColumnsValues;
  };

  // responsible for lowercasing the rows keys
  const getLowercaseRowsValue = (rows) => {
    const lowercaseRowsValues = rows.map((row) => {
      const lowercaseRow = {};
      for (let key in row) {
        lowercaseRow[key.toLowerCase()] = row[key];
      }
      return lowercaseRow;
    });

    return lowercaseRowsValues;
  };

  let loweredCaseColumns = getLowercaseColumnsValues(columns);
  let loweredCaseRows = getLowercaseRowsValue(rows);

  let generatedData = generateColumnsData(loweredCaseColumns, loweredCaseRows);

  let tableColumns = columnBuilder(generatedData);

  return (
    <div className="flex flex-col justify-between items-start gap-7">
      {/* Report Header */}
      <div className="w-full flex-row flex justify-between items-start ">
        <div className=" flex-1 space-y-3">
          {info.name !== "." && (
            <h1 className="text-2xl font-bold"> {info.name}</h1>
          )}
          {info.heading !== "." && (
            <h2 className="text-lg font-semibold text-gray-500">
              {info.heading}
            </h2>
          )}
          {info.subheading !== "." && (
            <p className="text-lg text-gray-500"> {info.subheading}</p>
          )}
        </div>
        <div className="">
          <button
            type="button"
            onClick={handleGoBack}
            className="flex items-center gap-2 p-2 py-2 px-3 text-center text-sm  text-gray-600"
          >
            <div className="h-4 w-4">
              <ArrowLeftIcon />
            </div>
            <div className=" text-base ">Go Back To Reports</div>
          </button>
        </div>
      </div>
      <div className=" w-full overflow-auto">
        {rows.length === 0 ? (
          <NoData />
        ) : (
          <Table
            data={generatedData}
            columns={tableColumns}
            name={info.name}
            actions={[]}
          />
        )}
      </div>
      <div>
        {info.footer !== "." && (
          <h3 className="text-lg text-gray-500">{info.footer}</h3>
        )}
      </div>
    </div>
  );
};

export default ViewReport;
